import React, {useEffect, useState} from "react";
import BackBtn from "../components/BackBtn";
import VehicleFeatures from "../components/VehFeatures";
import { useSelectedVehicle } from "../context/vehicle.context";
import { useUser } from "../context/user.context";
import VehicleList from "../components/VehList";
import { VehicleInformation } from "../data/VehInfo";
import VehSelectPopup from "../components/VehSelectPopup";
import UserDetails from  "../components/UserDetailsForm.jsx";
import Footer from "../components/Footer";

const VehicleSelect = (options)=>{
    const vehData = null
    const { selVehData, setSelVehData } = useSelectedVehicle();
    const { userData, setUserData } = useUser();
    const [data, setData] = useState(vehData);

    useEffect(()=>{
        console.log('Vehicle Select Page - userData:', userData);
        if(!userData.isComplete()){
            // alert("Please complete user details before selecting a vehicle.");
            // window.location.href = "/";
        }
    }, [userData]);

    

    const cardClick = (vehKey)=>{
        console.log("Selected Vehicle: ", vehKey);
        setSelVehData({
            ...selVehData,
            vehKey: vehKey,
            selectingVariant: true
        });
    }

    const openUserDetailsForm = ()=>{
        setUserData({
            ...userData,
            windowVisible: true
        });
    }

    const saveUserDetails= (updatedUser)=>{
        setUserData(prev=>({
            ...prev,
            ...updatedUser,
            windowVisible: false
        }));
    }


    return (
        <>
        <div className="page vehicleSelectPage">
            <h2 className="page-title">Select Vehicle</h2>
            <BackBtn url="/"/>
            <VehicleList onSelect={cardClick} />
            {selVehData.vehKey && <VehSelectPopup />}
            {userData.windowVisible && <UserDetails user={userData} onSubmit={saveUserDetails} />}
        </div>
        <Footer userData={userData} onSubmit={openUserDetailsForm} />
        </>
    )
}

export default VehicleSelect;